var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C1.5 0.447716 1.94771 0 2.5 0H7.5L7.5 4C7.5 4.55228 7.94772 5 8.5 5L12.5 5L12.5 13C12.5 13.5523 12.0523 14 11.5 14L2.5 14C1.94772 14 1.5 13.5523 1.5 13V1ZM4.7 7H3.5V8H4.7V7ZM10.5 7H5.9V8H10.5V7ZM4.7 9H3.5V10H4.7V9ZM10.5 9H5.9V10H10.5V9ZM3.5 11H4.7V12H3.5V11ZM5.9 11H10.5V12H5.9V11Z",
    fill: "#7936D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0172 4L8.5 4V0.482842C8.5 0.304661 8.71543 0.215428 8.84142 0.34142L12.1586 3.65858C12.2846 3.78457 12.1953 4 12.0172 4Z",
    fill: "#7936D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePurple);
export default __webpack_public_path__ + "static/media/file_purple.9becb93b.svg";
export { ForwardRef as ReactComponent };